<template>
  <div class="agreement-wrap">
    <div class="main-title">{{appName}} User Agreement</div>
    <div class="article-content">
      Please read this User Agreement carefully before you register an account. This document defines the rights and obligations of both parties and protects legitimate interests of all users.
      Please pay close attention to the highlighted clauses throughout the agreement and make sure you fully understand all terms.
      You may not register, log in or use our services and software unless you accept all provisions of this Agreement. By completing registration, logging in or using our services, you confirm that you have read, understood and agreed to be legally bound by all rules herein.
      We reserve the right to revise, supplement or delete any content of this Agreement, including supplementary rules, privacy policies and function terms at any time. Updated versions will be released within our software without prior notice. If you disagree with the revised terms, please stop using our services immediately. Your continued use of the services after updates means you accept the new Agreement.
    </div>

    <div class="section-title">1. Account Rules</div>
    <div class="article-content">
      1.1 To access our services, you need to register or obtain an account. We have the right to adjust the account registration process at our discretion.
      <br /><br />
      1.2 Once you complete account registration, you authorize us to activate accounts for our other affiliated products simultaneously. The specific services are subject to our actual business operations.
      <br /><br />
      1.3 All accounts are owned by us, and you only hold the right to use them. It is forbidden to gift, lend, rent, transfer or sell any account.
      <br /><br />
      1.4 You shall take full responsibility for keeping your account safe. We will not be liable for account leakage or password theft caused by your negligence. All operations performed via your account will be deemed as your own behaviors, and you shall bear corresponding liabilities. Please contact us promptly if you find any unauthorized access to your account or password. You are strictly prohibited from using other users' accounts or passwords.
      <br /><br />
      1.5 You must use the software in compliance with this Agreement. We are entitled to suspend or terminate your service if you violate any clauses.
      <br /><br />
      1.6 If your account remains inactive for one consecutive year, we may reclaim or delete it without prior notice, and you shall bear all relevant risks. We also reserve the right to recover any account and username anytime according to operational needs.
      <br /><br />
    </div>

    <div class="section-title">2. Service Scope</div>
    <div class="article-content">
      2.1 The available functions of the software are subject to actual launch, including but not limited to video chat, in-app purchases and virtual gift delivery. We may adjust or modify service contents at any time without sending prior notice.
      <br /><br />
      2.2 You agree that we may deliver commercial promotions and service notifications to you via client push, SMS, email, web pages and other legal channels. For the normal operation of mobile services, we may collect basic information of your mobile device.
      <br /><br />
    </div>

    <div class="section-title">3. User Information Protection</div>
    <div class="article-content">
      3.1 During account registration and service use, you are required to submit real identity information in accordance with relevant laws and regulations. Incomplete, false or non-compliant information will lead to restrictions or suspension of your service access.
      <br /><br />
      3.2 To optimize service quality and upgrade product technology, we may collect and use your personal data, and disclose relevant information to authorized third parties. For detailed regulations, please refer to our Privacy Policy.
      <br /><br />
    </div>

    <div class="section-title">4. Content Guidelines & Usage Regulations</div>
    <div class="article-content">
      4.1 The term "Content" refers to all materials you create, upload, copy, publish or share on the platform, including avatars, usernames, personal profiles, texts, audios, images, videos, messages, external links and all data generated during service use.
      <br /><br />
      4.2 You are not allowed to use this software to create, upload or spread the following content, or engage in the listed improper behaviors:
      <br /><br />
      1) Content that endangers national security, discloses state secrets, subverts state power or undermines national unity;
      <br /><br />
      2) Content that harms national honor and interests;
      <br /><br />
      3) Content that incites ethnic hatred, discrimination or damages ethnic solidarity;
      <br /><br />
      4) Content that violates national religious policies, advocates cults or feudal superstition;
      <br /><br />
      5) Content that spreads rumors, disturbs public order or undermines social stability;
      <br /><br />
      6) Content that distributes pornographic, vulgar or suggestive materials;
      <br /><br />
      7) Content that promotes gambling, violence, murder or terrorism;
      <br /><br />
      8) Content that insults, defames others, infringes legitimate rights or conducts fraud;
      <br /><br />
      9) Content containing abusive, intimidating or threatening remarks;
      <br /><br />
      10) Acts of sending harassing messages, spam, malicious codes or phishing links;
      <br /><br />
      11) Content that discloses or steals others' privacy and personal information;
      <br /><br />
      12) Content that violates others' right of reputation, portrait right, intellectual property rights, trade secrets and other legal rights;
      <br /><br />
      13) Any content that harms the physical and mental health or legal rights of minors;
      <br /><br />
      14) Behaviors such as stalking or harassing other users;
      <br /><br />
      15) Content with false information or acts of impersonating others by stealing personal data;
      <br /><br />
      16) Acts of coercing or inducing other users to follow accounts, click links or share content;
      <br /><br />
      17) Content that fabricates facts or conceals the truth to mislead others;
      <br /><br />
      18) Content that releases commercial advertisements or sales information without permission;
      <br /><br />
      19) Creating a large number of fake accounts by technical means;
      <br /><br />
      20) Removing the copyright marks of this software;
      <br /><br />
      21) Conducting reverse engineering, decompilation or attempting to crack the source code of the software;
      <br /><br />
      22) Copying, modifying, reposting or building mirror websites to use our intellectual property without authorization;
      <br /><br />
      23) Tampering, intercepting or redeveloping public data and operating data of the software;
      <br /><br />
      24) Adding or deleting software functions, or spreading modified software and data to the public for any purpose;
      <br /><br />
      25) Logging in and using the software via unofficial plugins, external tools or hacking programs, or developing and distributing such unauthorized tools;
      <br /><br />
      26) Content that is rude, indecent or offensive to others;
      <br /><br />
      27) Any other content or behaviors that violate laws and regulations, infringe third-party rights or interfere with the normal operation of the software. We will review user-submitted content within 24 hours. Any violating content will be deleted directly, and serious violations will result in permanent account ban.
      <br /><br />
      4.3 All content you publish only represents your personal opinions, not the stance of our platform. We shall not be held responsible for any content or behaviors posted by users.
      <br /><br />
      4.4 You shall be fully liable for the authenticity, legality and validity of all information you publish. If your behaviors cause losses to us or any third party, you must make full compensation, and we reserve the right to pursue legal liabilities.
      <br /><br />
    </div>

    <div class="section-title">5. Third-Party Products & Services</div>
    <div class="article-content">
      5.1 Our platform displays advertisements and promotional content provided by third parties, and you agree to receive such ads during service use. Except as required by law, all transactions based on advertising content are at your own risk, and we take no relevant responsibilities.
      <br /><br />
      5.2 If you use third-party products or services linked in our software, you must abide by the rules of the corresponding platforms. We do not guarantee the security, accuracy and reliability of third-party services, and we will not be liable for any losses caused by them.
      <br /><br />
    </div>

    <div class="section-title">6. Membership Services</div>
    <div class="article-content">
      6.1 You may purchase membership services. The specific privileges and charging standards are subject to the content displayed on relevant service pages.
      <br /><br />
      6.2 We have the right to adjust membership fees and service contents at any time, and updates will be posted on the corresponding pages.
      <br /><br />
      6.3 Unless otherwise stipulated by laws, membership fees are non-refundable and non-transferable after payment. Membership will expire automatically when the term ends, and unused privileges cannot be extended or postponed.
      <br /><br />
      6.4 The personal information you submit for membership registration must be true and valid. Please update your information timely when changes occur, or you shall bear all consequences for failing to enjoy membership rights normally.
      <br /><br />
    </div>

    <div class="section-title">7. Subscription & Virtual Currency</div>
    <div class="article-content">
      7.1 Subscription
      We provide multiple subscription plans including one-month, two-month and three-month packages. Mobile subscription fees will be deducted from your iTunes or Google account. Subscriptions are set to auto-renew by default. To turn off auto-renewal, please operate at least 24 hours before the current period expires. Renewal fees may be charged within 24 hours prior to expiration. You can manage subscriptions and disable auto-renewal in your account settings. You cannot cancel an active subscription during its term, but you may turn off auto-renewal at any time.
      <br /><br />
      All subscription payments are non-refundable and non-transferable, regardless of service expiration or suspension. We may adjust subscription prices and privileges, stop providing subscription services or set expiration dates at our discretion. Subscriptions cannot be exchanged for cash.
      <br /><br />
      7.2 Virtual Currency
      Virtual Currency such as Diamonds you purchase or receive is owned by us, and you only have the right to use it. Virtual Currency can be used for posting stories, applying filters, video chat and other functions. We have the right to verify your identity and qualification for using Virtual Currency.
      <br /><br />
      We will not provide replacements, compensation or refunds for Virtual Currency due to service adjustment, suspension, system errors or other reasons. Virtual Currency cannot be sublicensed, refunded or transferred, even if it expires or is revoked. We may adjust prices and usage rules of Virtual Currency, stop its issuance or set expiration dates without notice or compensation. Virtual Currency cannot be converted into cash. All unused Virtual Currency will be cleared without compensation if your account is deleted or terminated. Virtual Currency is not personal property and shall not be traded privately.
      <br /><br />
      7.3 Payment Method
      Paid services can be purchased through third-party accounts such as Apple iTunes or Google Play. All charges will be shown on the bill of your third-party account. Please read and follow the terms of service of relevant payment platforms.
      <br /><br />
      7.4 Unsubscribe
      If you subscribe via a third-party platform, you must cancel the subscription on that platform in accordance with its rules. After cancellation, you can continue to enjoy privileges until the current billing cycle ends, and no partial refund will be offered.
      <br /><br />
      7.5 Term & Fees
      This Agreement remains effective during your use of our application, website and services. We may terminate your membership at any time without prior notice, and no refund will be given for unused fees. This Agreement shall still be valid after membership termination. We have the right to adjust service fees and terminate membership for agreement violation or overdue payment. Standard SMS, MMS and data charges will be charged by your mobile operator.
      <br /><br />
    </div>

    <div class="section-title">8. Data Storage</div>
    <div class="article-content">
      8.1 We assume no liability for data loss or deletion within our services.
      <br /><br />
      8.2 We may set the maximum storage time and capacity for user data according to actual conditions. We recommend you back up important data by yourself.
      <br /><br />
      8.3 If you stop using the service, or the service is terminated or expired, we may permanently delete your data from servers with no obligation to return your data.
      <br /><br />
      8.4 You are allowed to modify or delete your personal information and published content. Deleting relevant data may cause associated content to be removed, and you shall take full risks for this operation.
      <br /><br />
    </div>

    <div class="section-title">9. Risk Statement</div>
    <div class="article-content">
      9.1 This software is only an information sharing and transmission platform. You shall take full responsibility for all operations under your account and their consequences. You need to judge the content independently and bear all risks arising from service use. We will not be responsible for any losses caused by your personal behaviors.
      <br /><br />
      9.2 Please report any users who violate this Agreement or use the service improperly, and we will take corresponding measures in accordance with rules.
      <br /><br />
      9.3 We may adjust, suspend, terminate or update any service functions at any time without prior notice.
      <br /><br />
    </div>

    <div class="section-title">10. Intellectual Property Rights</div>
    <div class="article-content">
      10.1 Except for content owned by advertisers, all intellectual property rights related to our services belong to us. If you legally own the intellectual property of content you posted before using our services, such rights shall remain yours.
      <br /><br />
      10.2 All copyrights, patents and other intellectual property rights of this software are exclusively owned by us.
      <br /><br />
      10.3 The copyright and trademark rights of software graphics, texts, logos, product and service names belong to us. Without our written permission, no one is allowed to display, use or modify these logos in any form.
      <br /><br />
      10.4 All intellectual property rights owned by us and cooperative advertisers are protected by law. Any use or derivative creation without written authorization is prohibited.
      <br /><br />
      10.5 You retain the intellectual property rights of texts, images, videos, audios and other content you upload. Meanwhile, you grant us and our affiliates an irrevocable, permanent, exclusive, royalty-free and worldwide sublicenseable right to use, display, reproduce, adapt, broadcast, rent, translate and distribute such content for commercial or non-commercial purposes. We may choose the usage methods freely, including editing the content and authorizing third parties to use and spread it.
      <br /><br />
    </div>

    <div class="section-title">11. Liability Clause</div>
    <div class="article-content">
      11.1 If you commit illegal acts, breach the Agreement or infringe others' rights, we may take measures including issuing warnings, restricting partial functions, terminating service access, blacklisting your account, publicizing your violations, deducting or freezing virtual items. If your account is terminated or blacklisted, no refund for virtual assets will be provided.
      <br /><br />
      11.2 We have the right to take legal actions and report relevant information to competent authorities against your violations, and you shall bear all corresponding results.
      <br /><br />
      11.3 You shall compensate for all losses and third-party claims caused by your violations, including reasonable attorney fees.
      <br /><br />
      11.4 You agree to indemnify and hold us and our affiliates harmless from all complaints, claims, losses, costs and liabilities (including attorney fees) arising from your service use or breach of this Agreement.
      <br /><br />
      11.5 We may take the above remedial measures separately or jointly.
      <br /><br />
    </div>

    <div class="section-title">12. Force Majeure & Disclaimer</div>
    <div class="article-content">
      12.1 We are not liable for service interruptions caused by uncontrollable factors such as natural disasters, wars, riots and government actions. We will try our best to repair and restore services as soon as possible.
      <br /><br />
      12.2 We do not guarantee that the service will always be safe, stable, uninterrupted or error-free. To the fullest extent permitted by law, we make no express or implied warranties of any kind. We are not responsible for the content and behaviors of other users.
      <br /><br />
      12.3 Internet conditions, external software, viruses and other security threats may affect the normal use of services. Please strengthen the protection of your device, account and personal data to avoid loss and harassment.
      <br /><br />
      12.4 We are not liable for any losses caused by service interruptions due to network failures, hacker attacks, system instability, device shutdown and other technical problems.
      <br /><br />
      12.5 The platform may contain misleading, threatening, defamatory, offensive, illegal or infringing content. We will not be responsible for any losses arising from such information.
      <br /><br />
      12.6 We will conduct regular or irregular maintenance, updates and repairs for the software. We assume no liability for temporary service suspension with prior notice.
      <br /><br />
      12.7 We have the right but no obligation to handle violations committed by third parties, and we cannot guarantee to discover and dispose of such behaviors in a timely manner.
      <br /><br />
      12.8 We are not responsible for quality defects of free products and services, or any damages caused by them.
      <br /><br />
      12.9 We shall not be liable for any indirect, incidental, special or consequential damages including loss of profits, goodwill or data. The total compensation we need to pay shall not exceed the total fees you have paid to us.
      <br /><br />
      12.10 Meeting or trading with other users offline involves personal and property risks. You shall take full responsibility for all consequences arising from offline behaviors.
      <br /><br />
    </div>

    <div class="section-title">13. Miscellaneous Provisions</div>
    <div class="article-content">
      13.1 Please read this Agreement carefully, especially clauses about disclaimer, risks and liability restrictions. Minors shall read this Agreement under the supervision of their guardians.
      <br /><br />
      13.2 All rules and announcements released by us within the software are supplementary contents of this Agreement and have the same legal effect.
      <br /><br />
      13.3 This Agreement is governed by the laws of the Hong Kong Special Administrative Region. Any dispute arising from this Agreement shall be submitted to the Hong Kong International Arbitration Centre for final arbitration in accordance with its arbitration rules.
      <br /><br />
      13.4 If any clause of this Agreement is deemed invalid or unenforceable, it will not affect the validity of remaining clauses. Both parties shall negotiate to replace the invalid clause to achieve the original commercial purpose. For inquiries, please contact us via email: Scvia@Scvia.site
      <br /><br />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      appName: ""
    };
  },
  created() {}
};
</script>

<style scoped>
/* 整体卡片容器 */
.agreement-wrap {
  max-width: 900px;
  margin: 30px auto;
  padding: 30px 40px;
  background-color: #ffffff;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

/* 主标题 */
.main-title {
  font-size: 22px;
  font-weight: 700;
  text-align: center;
  color: #2c3e50;
  margin-bottom: 25px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e8e8e8;
}

/* 章节标题 */
.section-title {
  font-size: 17px;
  font-weight: 600;
  color: #2980b9;
  margin: 22px 0 10px 0;
  padding-left: 8px;
  border-left: 4px solid #2980b9;
  line-height: 1.5;
}

/* 正文内容 */
.article-content {
  font-size: 15px;
  line-height: 1.8;
  color: #444444;
  margin-bottom: 12px;
  text-align: left;
}

/* 移动端响应式适配 */
@media (max-width: 768px) {
  .agreement-wrap {
    margin: 15px;
    padding: 20px 18px;
  }
  .main-title {
    font-size: 20px;
  }
  .section-title {
    font-size: 16px;
  }
  .article-content {
    font-size: 14px;
  }
}
</style>